import React, { memo, useContext } from 'react';
import Chip from "../../../../components/Chip";
import { ChallengeDriverItem } from "../../../../types/gamification";
import TableChip from 'src/components/TableChip';
import Avatar from 'src/components/Avatar/indext';
import { AuthContext } from 'src/providers/AuthProvider';

interface Trip {
  driverName?: string;
  routeName?: string;
  destination?: string;
  tripDate?: string;
  vwcoin: number;
  status?: string;
}

interface RowProps {
  trip: ChallengeDriverItem;
}

const DEFAULT_ROUTE_NAME = 'Viagem';
const COIN_IMAGE_SIZE = 20;

const commonCellClasses = "text-base text-color-dark p-3 w-1/5 overflow-hidden text-ellipsis whitespace-nowrap";

/*const Row: React.FC<RowProps> = ({ trip }) => {
  const formattedDate = trip.tripDate 
    ? new Date(trip.tripDate).toLocaleDateString('pt-BR')
    : '';*/

const Row: React.FC<RowProps> = ({ trip }) => {

  const formattedDate = trip.tripDate
    ? new Date(trip.tripDate).toLocaleDateString('pt-BR')
    : '';
  const { getDetailUser, finderDriverFleet } = useContext(AuthContext);
  const user_amity = getDetailUser?.(trip.profileId);
  const finder = finderDriverFleet?.(trip.driverId);

  return (
    <tr className="bg-white hover:bg-gray-50">
      <td className="p-3 font-medium">
        <div className="display-flex flex-direction-row align-items-center">
          <Avatar
            url={user_amity?.metadata?.imageProfile?.fileUrl}
          />
          <div className="padding-x-15">
            <span className="text-bold text-size-16 text-capitalize">{trip.driverName}</span>
            <div className="margin-top-5">
              <TableChip
                disabledDriver={!finder}
                disabledProfile={!trip.profileId}
                user={user_amity}
              />
            </div>
          </div>
        </div>
      </td>
      <td className={commonCellClasses}>
        {trip.challegeName || "vazio"}
      </td>
      <td className={commonCellClasses}>
        {DEFAULT_ROUTE_NAME}
      </td>
      <td className={commonCellClasses}>
        {trip.tripDestination || "vazio"}
      </td>
      <td className={commonCellClasses}>
        {formattedDate}
      </td>
      <td className="p-3 text-color-rating-4 font-semibold flex items-center gap-1.5">
        <img src={require('src/assets/png/pointLogo.png')} alt="point" className="width-30 margin-right-5" />
        +{trip.points} pontos
      </td>
    </tr>
  );
};

export default memo(Row);